import 'devextreme/dist/css/dx.light.css';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import reportWebVitals from './reportWebVitals';

// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import ServiceWorkerWrapper from './ServiceWorkerWrapper';

const IdleApp = React.lazy(() => import(/* webpackChunkName: "IdleApp" */ './IdleApp'));

const Main = () => {
  return (
    <Provider store={configureStore()}>
      <Suspense fallback={<div className="loading" />}>
        <IdleApp />
      </Suspense>
    </Provider>
  );
};

ReactDOM.render(<Main />, document.getElementById('root'));

// serviceWorkerRegistration.unregister();
// serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();